<template>
    <div class="p-3">
        <div class="mb-2">
            <label v-if="commentLabel" :for="editorId">
                {{ commentLabel }}
            </label>
            <TextEditor
                :id="editorId"
                v-model="form.comment"
                :validation="$v.form.comment"
                container-class="field-comment-editor"
                :placeholder="placeholder || $t('Add a comment')">
                <template #menu="{ editor, disabled }">
                    <BubbleMenuBar :editor="editor" :disabled="disabled"/>
                </template>
            </TextEditor>
        </div>
        <div class="d-flex justify-content-end">
            <button v-if="showCancel" type="button" :disabled="loading" class="btn btn-secondary btn-sm" @click="cancel">
                {{ $t('Cancel') }}
            </button>
            <button
                type="button"
                :disabled="loading"
                class="btn btn-success btn-sm ml-2"
                @click="submit">
                {{ submitLabel || $t('Add') }}
            </button>
        </div>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import BubbleMenuBar from '@/common/components/tiptap/BubbleMenuBar.vue';
import TextEditor from '@/common/components/tiptap/TextEditor.vue';

export default {
    name: 'CommentInput',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        editorId: {
            type: String,
            default: 'comment'
        },
        showCancel: {
            type: Boolean,
            default: true
        },
        submitLabel: {
            type: String,
            default: ''
        },
        commentLabel: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        bubbleMenu: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                comment: ''
            }
        };
    },
    methods: {
        resetForm() {
            this.form.comment = '';
            this.$v.$reset();
        },
        cancel() {
            this.resetForm();
            this.$emit('cancel');
        },
        submit() {
            if (this.loading) {
                return;
            }
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.$emit('submit', this.form.comment);
        }
    },
    components: {
        BubbleMenuBar,
        TextEditor
    },
    validations: {
        form: {
            comment: { required }
        }
    }
};
</script>

<style scoped>
::v-deep .field-comment-editor .tiptap-editor-content {
    max-height: 150px;
    overflow-x: hidden;
    overflow-y: auto;
}
</style>
